import React, { useState } from 'react';
import './Navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Link as ScrollLink } from 'react-scroll';

const Navbar = () => {
  const [searchActive, setSearchActive] = useState(false);
  const [navActive, setNavActive] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  const toggleSearch = () => {
    setSearchActive(!searchActive);
    setSearchQuery('');
    setSearchResults([]);
  };

  const toggleNav = () => {
    setNavActive(!navActive);
  };

  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const sections = [
      { id: 'home', title: 'Home', keywords: ['home', 'landing'] },
      { id: 'about', title: 'About', keywords: ['about', 'me', 'biography'] },
      { id: 'portfolio', title: 'Portfolio', keywords: ['portfolio', 'projects', 'work'] },
      { id: 'resume', title: 'Resume', keywords: ['resume', 'cv', 'experience'] },
      { id: 'education', title: 'Education', keywords: ['education', 'school', 'university'] },
      { id: 'contact', title: 'Contact', keywords: ['contact', 'reach', 'email'] }
    ];

    const results = sections.filter(section =>
      section.keywords.some(keyword => keyword.includes(query))
    );

    setSearchResults(results);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <div className="profile-picture">
          <img src="boy1.png" alt="Profile" />
        </div>
        <a href="#home" className="navbar-name">Hamid</a>
      </div>
      <FontAwesomeIcon
        icon={navActive ? faTimes : faBars}
        className="toggle-icon"
        onClick={toggleNav}
        aria-label={navActive ? 'Close menu' : 'Open menu'}
      />
      <ul className={`navbar-links ${navActive ? 'active' : ''}`}>
        <li><ScrollLink to="home" smooth={true} duration={500} offset={-70}>Home</ScrollLink></li>
        <li><ScrollLink to="about" smooth={true} duration={500} offset={-70}>About</ScrollLink></li>
        <li><ScrollLink to="portfolio" smooth={true} duration={500} offset={-70}>Portfolio</ScrollLink></li>
        <li><ScrollLink to="resume" smooth={true} duration={500} offset={-70}>Resume</ScrollLink></li>
        <li><ScrollLink to="education" smooth={true} duration={500} offset={-70}>Education</ScrollLink></li>
        <li><ScrollLink to="contact" smooth={true} duration={500} offset={-70}>Contact</ScrollLink></li>
      </ul>
      <div className={`navbar-search ${searchActive ? 'active' : ''}`}>
        <FontAwesomeIcon
          icon={faSearch}
          className="search-icon"
          onClick={toggleSearch}
          aria-label="Search"
        />
        <input
          type="text"
          className={`search-bar ${searchActive ? 'active' : ''}`}
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search..."
          autoFocus={searchActive}
        />
      </div>
      {searchActive && searchResults.length > 0 && (
        <div className="search-results">
          <ul>
            {searchResults.map((result, index) => (
              <li key={index}>
                <ScrollLink to={result.id} smooth={true} duration={500} offset={-70}>
                  {result.title}
                </ScrollLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
